// Updated questionsData.js to fetch from API
let questionsCache = {};
let lastFetchTime = {};

export const getQuestions = async (formType = '1040') => {
  const cacheKey = formType;
  const now = Date.now();
  const cacheTimeout = 5 * 60 * 1000; // 5 minutes
  
  // Check if we have cached data that's still valid
  if (
    questionsCache[cacheKey] && 
    lastFetchTime[cacheKey] && 
    (now - lastFetchTime[cacheKey]) < cacheTimeout
  ) {
    return questionsCache[cacheKey];
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/questions/form/${formType}`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch questions');
    }

    const data = await response.json();
    
    // Cache the results
    questionsCache[cacheKey] = data.data;
    lastFetchTime[cacheKey] = now;
    
    return data.data;
  } catch (error) {
    console.error('Error fetching questions:', error);
    
    // Return fallback data if API fails
    return getFallbackQuestions(formType);
  }
};

// Fallback questions (your original static data)
const getFallbackQuestions = (formType) => {
  const fallbackQuestions = {
    "1040": {
      "Document Upload by Client": [
        "Prior-year tax return copy (for reference)",
        "W-2 forms from all employers",
        "1099-NEC (Self-employment income)",
        "1099-K (Payments from platforms like PayPal, Stripe, etc.)",
        "1099-INT (Interest income)",
        "1099-DIV (Dividends received)",
        "1099-B (Stocks, bonds, or cryptocurrency sales)",
        "Social Security income (SSA-1099)",
        "1099-R (Retirement distributions)",
        "1099-G (Unemployment benefits)",
        "W-2G (Gambling winnings)",
        "1098-E (Student loan interest)",
        "5498 (IRA contributions)",
        "5498-SA (HSA contributions)",
        "1098 (Mortgage interest)",
        "Education credit (1098-T)",
        "Form K1 document If any",
        "Business income & expense records",
        "Rental income & expenses"
      ],
      "Basic Information of Client": [
        "Taxpayer's full name",
        "Taxpayer's SSN",
        "Taxpayer's Date of Birth",
        "Spouse's full name(if applicable)",
        "Spouse's SSN",
        "Spouse's Date of Birth",
        "Current mailing address",
        "Contact details",
        "Filing status (Single, MFJ, MFS, HOH, Qualifying Widow(er))",
        "Dependents' names SSNs, and dates of birth",
        "Dependents SSN",
        "Dependents date of birth",
        "Bank account details for direct deposit:-",
        "Do you want your refund directly deposited?",
        "Do you want your tax balance directly drafted?",
        "Bank Name",
        "Routing Number (9 Digits).",
        "Account Number",
        "Type of Account-Checking or Savings",
        "Quarterly estimated tax payments made",
        "Is you traded in any virtual currency in 2024?"
      ],
      "Are you having any foreign financials accounts (outside USA)?": [
        "FBAR/Form 8938 (Foreign accounts & assets)",
        "Asset Type",
        "Individual/ Joint Ownership",
        "Account Number",
        "Name of Financial Institution/Corporation",
        "Complete Address of Financial Institution/Corporation",
        "Maximum Foreign Currency Value During 2024",
        "Foreign Currency Value as of 12/31/2024",
        "Foreign Currency Unit",
        "Exchange Rate",
        "Form 8621 Mutual Fund or Any Passive Funds Hold outside USA",
        "Fund name",
        "Reference ID",
        "Adress (Including Street,City,State,Pincode)",
        "No Of Units Held at the end of Taxable Year.(2024)",
        "Value Of Units held at the end of the taxable Year.(2024)",
        "Adjusted basis (FMV of last year) (12/31/23)",
        "Current Yr Investment at Cost in 2024 $",
        "Adjusted basis at end of tax year",
        "FMV on date of sale",
        "Adjusted basis on date of sale"
      ]
    },
    "1065": {
      "Basic Information": [
        "Name of Partnership",
        "Address of Partnership Entity",
        "Employer Identification Number (EIN) as registered with the IRS",
        "Principal Business Activity",
        "Its year initial return or Final return?",
        "Do you change the name of partnership and address from last return? If address change than provide the updated one.",
        "Date of Business Started",
        "Nature of business entity (Is it Domestic general partnership, Domestic limited partnership, Domestic limited liability company, Domestic limited liability partnership or Foreign partnership?)",
        "Accounting Method (Cash, Accrual or other)",
        "List of states and state ID numbers in which your business has nexus or a presence that requires reporting",
        "Last year's federal, state, and local tax returns (If any)",
        "All amounts and dates for federal, state and local estimated tax payments made with date"
      ],
      "Partners Information": [
        "Name, address, and SSN/EIN of each partner during the tax year",
        "List of each partner's profit/loss/ownership percentage",
        "Reports for all owner capital contributions, withdrawals, or loans",
        "Reports for all partner guaranteed payments, compensation, and benefits including cost of medical and life insurance",
        "Reports detailing any change in ownership during the tax year"
      ],
      "Documents Required": [
        "All Forms 1099-B, 1099-DIV, 1099-INT, 1099-K, or 1099-MISC received and all other 1099 and W-2 forms (or other records for dividends, interest, or business income)",
        "Schedule K-1 received from entities that your business owns",
        "All granted credit certificates issued by federal or state taxing authorities"
      ],
      "Business and Financial Records": [
        "Balance Sheet for the period ended tax year.",
        "Profit & Loss Account for the tax year period.",
        "Reports detailing all federal unemployment, Social Security, and Medicare tax paid (Forms 940 & 941)",
        "Date of purchase, cost, trade-in allowance, and business use percentage for all assets acquired during the tax year",
        "Date of purchase, cost, sales proceeds, trade-in allowance, expenses of the sale, and accumulated depreciation for all assets disposed of during the tax year"
      ]
    },
    "1120-S": {
      "Basic Information": [
        "EIN as registered with the IRS",
        "List of states and state ID numbers in which your business has nexus or a presence that requires reporting",
        "Copy of articles of incorporation or bylaws including any amendments",
        "Copy of IRS acceptance letter of S Corp election or previously filed Form 2553",
        "Last year's federal, state, and local tax returns",
        "All amounts and dates for state and local estimated tax payments made"
      ],
      "Shareholders Info": [
        "Name, address, and SSN/EIN of each Shareholder during the tax year",
        "List of each shareholder's stock ownership",
        "Reports for all shareholder's capital contributions, withdrawals, or loans",
        "Reports for all shareholder's compensation and benefits including cost of medical and life insurance",
        "Reports detailing any change in ownership during the tax year"
      ],
      "Documents Received": [
        "All Forms 1099-B, 1099-DIV, 1099-INT, 1099-K, or 1099-MISC received (or other records for dividends, interest, or business income)",
        "Schedule K-1 received from entities that your business owns (lower tier entities)",
        "All granted credit certificates issued by federal or state taxing authorities"
      ],
      "Business and Financial Records": [
        "Trial balance report from company books.",
        "Copy or summary of all Form 1099 and W-2 issued",
        "Reports detailing all federal unemployment, Social Security, and Medicare tax paid (Forms 940 & 941)",
        "Reports of state and local payroll tax paid",
        "Date of purchase, cost, trade-in allowance, and business use percentage for all assets acquired during the tax year",
        "Date of purchase, cost, sales proceeds, trade-in allowance, expenses of the sale, and accumulated depreciation for all assets disposed of during the tax year"
      ]
    },
    "1120": {
      "Basic Information": [
        "Name of Corporation",
        "Address of Corporation",
        "Employer Identification Number (EIN) as registered with the IRS",
        "Principal Business Activity",
        "Its year initial return or Final return?",
        "Do you change the name of corporations and address from last return? If yes than provide the updated address",
        "Date of Business Started",
        "Accounting Method (Cash, Accrual or other)",
        "List of states and state ID numbers in which your business has nexus or a presence that requires reporting",
        "Last year's federal, state, and local tax returns (If any)",
        "All amounts and dates for federal, state and local estimated tax payments made with date"
      ],
      "Documents Required": [
        "All Forms 1099-B, 1099-DIV, 1099-INT, 1099-K, or 1099-MISC received and all other 1099 and W-2 forms issued (or other records for dividends, interest, or business income)",
        "Form W-3",
        "Copies of Schedule K-1's received for investments owned by this entity"
      ],
      "Business and Financial Records": [
        "Trial balance report from company books.",
        "Reports detailing all federal unemployment, Social Security, and Medicare tax paid (Forms 940 & 941)",
        "Date of purchase, cost, trade-in allowance, and business use percentage for all assets acquired during the tax year",
        "Date of purchase, cost, sales proceeds, trade-in allowance, expenses of the sale, and accumulated depreciation for all assets disposed of during the tax year",
        "Has there been a change in ownership? If yes, please provide the date(s) and ownership percentages that changed. Also include the amounts involved in the ownership change transaction. We will need the name, address, SSN or EIN of any new shareholder."
      ]
    }
  };

  return fallbackQuestions[formType] || fallbackQuestions["1040"];
};

// Clear cache function
export const clearQuestionsCache = () => {
  questionsCache = {};
  lastFetchTime = {};
};

// Export the questions as before for backward compatibility
export const questions = {
  getQuestions,
  clearCache: clearQuestionsCache
};